// Mock data for Customer Budget Planning System

export const MONTHS = [
  { key: 'apr', label: 'Apr' },
  { key: 'may', label: 'May' },
  { key: 'jun', label: 'Jun' },
  { key: 'jul', label: 'Jul' },
  { key: 'aug', label: 'Aug' },
  { key: 'sep', label: 'Sep' },
  { key: 'oct', label: 'Oct' },
  { key: 'nov', label: 'Nov' },
  { key: 'dec', label: 'Dec' },
  { key: 'jan', label: 'Jan' },
  { key: 'feb', label: 'Feb' },
  { key: 'mar', label: 'Mar' },
];

export const PIPELINES = [
  { id: 'new-deal', name: 'NEW DEAL', color: 'blue' },
  { id: 'repeat-deal', name: 'REPEAT DEAL', color: 'green' },
  { id: 'win-back', name: 'WIN BACK', color: 'orange' },
  { id: 'up-selling', name: 'UP SELLING', color: 'purple' },
  { id: 'cross-selling', name: 'CROSS SELLING', color: 'cyan' },
  { id: 'indenting-deal', name: 'INDENTING DEAL', color: 'teal' },
];

export const PRODUCT_GROUPS = [
  { id: 'pg-001', name: 'Industrial Lubricants' },
  { id: 'pg-002', name: 'Automotive Oils' },
  { id: 'pg-003', name: 'Hydraulic Fluids' },
  { id: 'pg-004', name: 'Cutting & Cooling' },
  { id: 'pg-005', name: 'Specialty Products' },
];

export const DIVISIONS = [
  { id: 'intercom', name: 'INTERCOM', color: 'blue' },
  { id: 'rimcore', name: 'RIMCORE', color: 'green' },
  { id: 'tapes', name: 'TAPES', color: 'orange' },
];

export const ACCOUNT_MANAGERS = [
  { id: 'am-001', name: 'Rajesh Kumar', email: 'rajesh.kumar@skiverse.com', isApproved: false },
  { id: 'am-002', name: 'Priya Sharma', email: 'priya.sharma@skiverse.com', isApproved: true },
  { id: 'am-003', name: 'Amit Patel', email: 'amit.patel@skiverse.com', isApproved: false },
  { id: 'am-004', name: 'Sneha Gupta', email: 'sneha.gupta@skiverse.com', isApproved: false },
  { id: 'am-005', name: 'Vikram Singh', email: 'vikram.singh@skiverse.com', isApproved: false },
];

export const customers = [
  // INTERCOM Division - Rajesh Kumar
  {
    id: 'cust-001',
    name: 'Reliance Industries Ltd',
    code: 'RIL-001',
    division: 'INTERCOM',
    accountManager: 'Rajesh Kumar',
    accountManagerId: 'am-001',
    lastUpdated: '2025-01-15T10:30:00Z',
    status: 'completed',
    lastYearTotal: 24500000,
    thisYearTotal: 26800000,
  },
  {
    id: 'cust-002',
    name: 'Tata Steel Limited',
    code: 'TSL-002',
    division: 'INTERCOM',
    accountManager: 'Rajesh Kumar',
    accountManagerId: 'am-001',
    lastUpdated: '2025-01-14T15:45:00Z',
    status: 'pending',
    lastYearTotal: 18700000,
    thisYearTotal: 19200000,
  },
  // INTERCOM Division - Priya Sharma
  {
    id: 'cust-003',
    name: 'Infosys Technologies',
    code: 'INF-003',
    division: 'INTERCOM',
    accountManager: 'Priya Sharma',
    accountManagerId: 'am-002',
    lastUpdated: '2025-01-13T09:15:00Z',
    status: 'pending',
    lastYearTotal: 12300000,
    thisYearTotal: 13500000,
  },
  {
    id: 'cust-004',
    name: 'Hindustan Unilever',
    code: 'HUL-004',
    division: 'INTERCOM',
    accountManager: 'Priya Sharma',
    accountManagerId: 'am-002',
    lastUpdated: '2025-01-12T14:20:00Z',
    status: 'completed',
    lastYearTotal: 31200000,
    thisYearTotal: 34100000,
  },
  // RIMCORE Division - Amit Patel
  {
    id: 'cust-005',
    name: 'Bharti Airtel',
    code: 'BAL-005',
    division: 'RIMCORE',
    accountManager: 'Amit Patel',
    accountManagerId: 'am-003',
    lastUpdated: '2025-01-11T11:00:00Z',
    status: 'pending',
    lastYearTotal: 22800000,
    thisYearTotal: 24500000,
  },
  {
    id: 'cust-006',
    name: 'Larsen & Toubro',
    code: 'LNT-006',
    division: 'RIMCORE',
    accountManager: 'Amit Patel',
    accountManagerId: 'am-003',
    lastUpdated: '2025-01-10T16:30:00Z',
    status: 'completed',
    lastYearTotal: 45600000,
    thisYearTotal: 48200000,
  },
  // RIMCORE Division - Sneha Gupta
  {
    id: 'cust-007',
    name: 'ICICI Bank',
    code: 'ICB-007',
    division: 'RIMCORE',
    accountManager: 'Sneha Gupta',
    accountManagerId: 'am-004',
    lastUpdated: '2025-01-09T08:45:00Z',
    status: 'pending',
    lastYearTotal: 19400000,
    thisYearTotal: 21000000,
  },
  {
    id: 'cust-008',
    name: 'Mahindra & Mahindra',
    code: 'MNM-008',
    division: 'RIMCORE',
    accountManager: 'Sneha Gupta',
    accountManagerId: 'am-004',
    lastUpdated: '2025-01-08T13:10:00Z',
    status: 'pending',
    lastYearTotal: 27500000,
    thisYearTotal: 29800000,
  },
  // TAPES Division - Vikram Singh
  {
    id: 'cust-009',
    name: 'Sun Pharmaceutical',
    code: 'SUN-009',
    division: 'TAPES',
    accountManager: 'Vikram Singh',
    accountManagerId: 'am-005',
    lastUpdated: '2025-01-07T10:00:00Z',
    status: 'completed',
    lastYearTotal: 16800000,
    thisYearTotal: 18200000,
  },
  {
    id: 'cust-010',
    name: 'Asian Paints',
    code: 'APL-010',
    division: 'TAPES',
    accountManager: 'Vikram Singh',
    accountManagerId: 'am-005',
    lastUpdated: '2025-01-06T17:20:00Z',
    status: 'completed',
    lastYearTotal: 14200000,
    thisYearTotal: 15600000,
  },
  // TAPES Division - Rajesh Kumar
  {
    id: 'cust-011',
    name: 'Wipro Limited',
    code: 'WIP-011',
    division: 'TAPES',
    accountManager: 'Rajesh Kumar',
    accountManagerId: 'am-001',
    lastUpdated: '2025-01-05T09:30:00Z',
    status: 'completed',
    lastYearTotal: 21500000,
    thisYearTotal: 23400000,
  },
  {
    id: 'cust-012',
    name: 'Bajaj Auto',
    code: 'BAJ-012',
    division: 'TAPES',
    accountManager: 'Rajesh Kumar',
    accountManagerId: 'am-001',
    lastUpdated: '2025-01-04T14:15:00Z',
    status: 'pending',
    lastYearTotal: 33800000,
    thisYearTotal: 36500000,
  },
];

// Generate products for budget by product name
export const generateProductBudget = (customerId) => {
  const productBases = [
    { name: 'Industrial Lubricant', list1: 'Grade A', list2: 'Bulk', productGroup: 'Industrial Lubricants' },
    { name: 'Hydraulic Oil', list1: 'Premium', list2: 'Drum', productGroup: 'Hydraulic Fluids' },
    { name: 'Engine Oil', list1: 'Synthetic', list2: 'Case', productGroup: 'Automotive Oils' },
    { name: 'Gear Oil', list1: 'Heavy Duty', list2: 'Barrel', productGroup: 'Automotive Oils' },
    { name: 'Transformer Oil', list1: 'Class II', list2: 'Tank', productGroup: 'Specialty Products' },
    { name: 'Compressor Oil', list1: 'Food Grade', list2: 'IBC', productGroup: 'Industrial Lubricants' },
    { name: 'Turbine Oil', list1: 'EP 220', list2: 'Bulk', productGroup: 'Industrial Lubricants' },
    { name: 'Cutting Fluid', list1: 'Soluble', list2: 'Drum', productGroup: 'Cutting & Cooling' },
    { name: 'Rust Preventive', list1: 'Water Based', list2: 'Pail', productGroup: 'Specialty Products' },
    { name: 'Grease', list1: 'Lithium', list2: 'Cartridge', productGroup: 'Industrial Lubricants' },
    { name: 'Coolant', list1: 'Concentrate', list2: 'Drum', productGroup: 'Cutting & Cooling' },
    { name: 'Brake Fluid', list1: 'DOT 4', list2: 'Bottle', productGroup: 'Automotive Oils' },
  ];

  const products = [];
  
  PIPELINES.forEach(pipeline => {
    productBases.forEach((product, index) => {
      const rate = Math.floor(Math.random() * 5000) + 500;
      const monthlyData = {};
      
      MONTHS.forEach(month => {
        const qty = Math.floor(Math.random() * 100);
        monthlyData[`${month.key}Qty`] = qty;
        monthlyData[`${month.key}Amount`] = qty * rate;
      });

      const totalQty = MONTHS.reduce((sum, m) => sum + (monthlyData[`${m.key}Qty`] || 0), 0);
      const totalAmount = MONTHS.reduce((sum, m) => sum + (monthlyData[`${m.key}Amount`] || 0), 0);

      products.push({
        id: `${pipeline.id}-prod-${index + 1}`,
        pipeline: pipeline.name,
        pipelineId: pipeline.id,
        productGroup: product.productGroup,
        productName: product.name,
        list1: product.list1,
        list2: product.list2,
        rate,
        ...monthlyData,
        totalQty,
        totalAmount,
      });
    });
  });

  return products;
};

// Generate MERGED budget data (both product names and product groups combined)
// - Rows with productName: Rate is fixed, only Qty editable, Amount = Qty * Rate
// - Rows with only productGroup (no productName): Amount editable, Rate = 1, Qty = Amount
// Includes order history data for color coding based on frequency rules
export const generateMergedBudget = (customerId) => {
  const productBases = [
    { name: 'Industrial Lubricant', list1: 'Grade A', list2: 'Bulk', productGroup: 'Industrial Lubricants' },
    { name: 'Hydraulic Oil', list1: 'Premium', list2: 'Drum', productGroup: 'Hydraulic Fluids' },
    { name: 'Engine Oil', list1: 'Synthetic', list2: 'Case', productGroup: 'Automotive Oils' },
    { name: 'Gear Oil', list1: 'Heavy Duty', list2: 'Barrel', productGroup: 'Automotive Oils' },
    { name: 'Transformer Oil', list1: 'Class II', list2: 'Tank', productGroup: 'Specialty Products' },
    { name: 'Compressor Oil', list1: 'Food Grade', list2: 'IBC', productGroup: 'Industrial Lubricants' },
  ];

  // Color rules based on order frequency:
  // GREEN: >8 months in last FY, OR >4 times in last 8 months + at least in last 2 months, OR <8 months last FY but similar trend prev FY
  // YELLOW: Not taken in last 4 months, OR taken in last 2 months but not before (new product)
  // RED: Taken only 1 time in last FY and not taken any other time before
  const getProductColor = (orderData) => {
    const { orderMonthsLastFY, orderMonthsPrevFY, orderCountLast8Months, orderedLast2Months, orderedLast4Months, isNewProduct, totalOrdersAllTime } = orderData;
    
    // Rule 6 (RED): Taken ONE TIME in last FY AND not taken any other time
    if (orderMonthsLastFY === 1 && orderMonthsPrevFY === 0 && totalOrdersAllTime === 1) {
      return 'red';
    }
    
    // Rule 1 (GREEN): Taken MORE THAN 8 months in last financial year
    if (orderMonthsLastFY > 8) {
      return 'green';
    }
    
    // Rule 3 (GREEN): Taken MORE THAN 4 times in last 8 months AND at least in last 2 months
    if (orderCountLast8Months > 4 && orderedLast2Months) {
      return 'green';
    }
    
    // Rule 4 (GREEN): Less than 8 months in last FY BUT similar trend previous FY
    if (orderMonthsLastFY < 8 && orderMonthsLastFY > 0) {
      if (Math.abs(orderMonthsLastFY - orderMonthsPrevFY) <= 2 && orderMonthsPrevFY > 0) {
        return 'green';
      }
    }
    
    // Rule 5 (YELLOW): Taken in last 2 months BUT NOT before (new product)
    if (isNewProduct || (orderedLast2Months && totalOrdersAllTime <= 2)) {
      return 'yellow';
    }
    
    // Rule 2 (YELLOW): NOT taken in last 4 months
    if (!orderedLast4Months) {
      return 'yellow';
    }
    
    // Default: no special color
    return 'default';
  };

  // Generate random order history data for demo
  const generateOrderHistory = () => {
    const scenarios = [
      // GREEN scenarios
      { orderMonthsLastFY: 10, orderMonthsPrevFY: 9, orderCountLast8Months: 6, orderedLast2Months: true, orderedLast4Months: true, isNewProduct: false, totalOrdersAllTime: 24 },
      { orderMonthsLastFY: 9, orderMonthsPrevFY: 8, orderCountLast8Months: 5, orderedLast2Months: true, orderedLast4Months: true, isNewProduct: false, totalOrdersAllTime: 20 },
      { orderMonthsLastFY: 6, orderMonthsPrevFY: 5, orderCountLast8Months: 5, orderedLast2Months: true, orderedLast4Months: true, isNewProduct: false, totalOrdersAllTime: 14 },
      { orderMonthsLastFY: 4, orderMonthsPrevFY: 5, orderCountLast8Months: 3, orderedLast2Months: true, orderedLast4Months: true, isNewProduct: false, totalOrdersAllTime: 10 },
      // YELLOW scenarios
      { orderMonthsLastFY: 3, orderMonthsPrevFY: 2, orderCountLast8Months: 2, orderedLast2Months: false, orderedLast4Months: false, isNewProduct: false, totalOrdersAllTime: 6 },
      { orderMonthsLastFY: 2, orderMonthsPrevFY: 0, orderCountLast8Months: 2, orderedLast2Months: true, orderedLast4Months: true, isNewProduct: true, totalOrdersAllTime: 2 },
      { orderMonthsLastFY: 5, orderMonthsPrevFY: 4, orderCountLast8Months: 3, orderedLast2Months: false, orderedLast4Months: false, isNewProduct: false, totalOrdersAllTime: 12 },
      // RED scenarios
      { orderMonthsLastFY: 1, orderMonthsPrevFY: 0, orderCountLast8Months: 1, orderedLast2Months: false, orderedLast4Months: true, isNewProduct: false, totalOrdersAllTime: 1 },
    ];
    return scenarios[Math.floor(Math.random() * scenarios.length)];
  };

  const products = [];
  
  PIPELINES.forEach(pipeline => {
    // Add product name rows (with rate, qty editable)
    productBases.forEach((product, index) => {
      const rate = Math.floor(Math.random() * 5000) + 500;
      const monthlyData = {};
      
      MONTHS.forEach(month => {
        const qty = Math.floor(Math.random() * 100);
        monthlyData[`${month.key}Qty`] = qty;
        monthlyData[`${month.key}Amount`] = qty * rate;
      });

      const totalQty = MONTHS.reduce((sum, m) => sum + (monthlyData[`${m.key}Qty`] || 0), 0);
      const totalAmount = MONTHS.reduce((sum, m) => sum + (monthlyData[`${m.key}Amount`] || 0), 0);

      // Generate order history for color coding
      const orderHistory = generateOrderHistory();
      const color = getProductColor(orderHistory);

      products.push({
        id: `${pipeline.id}-prod-${index + 1}`,
        pipeline: pipeline.name,
        pipelineId: pipeline.id,
        productGroup: product.productGroup,
        productName: product.name,
        list1: product.list1,
        list2: product.list2,
        rate,
        isProductNameRow: true,
        color, // Color based on order frequency
        assignedEmployee: null, // For cross-selling reassignment
        ...orderHistory, // Include order history data
        ...monthlyData,
        totalQty,
        totalAmount,
      });
    });

    // Add product group only rows (amount editable, no product name)
    PRODUCT_GROUPS.forEach((pg, index) => {
      const monthlyData = {};
      
      MONTHS.forEach(month => {
        const amount = Math.floor(Math.random() * 500000) + 50000;
        monthlyData[`${month.key}Amount`] = amount;
        monthlyData[`${month.key}Qty`] = amount; // Qty = Amount when Rate = 1
      });

      const totalAmount = MONTHS.reduce((sum, m) => sum + (monthlyData[`${m.key}Amount`] || 0), 0);
      const totalQty = totalAmount; // Qty = Amount when Rate = 1

      // Generate order history for color coding
      const orderHistory = generateOrderHistory();
      const color = getProductColor(orderHistory);

      products.push({
        id: `${pipeline.id}-pg-${pg.id}`,
        pipeline: pipeline.name,
        pipelineId: pipeline.id,
        productGroup: pg.name,
        productGroupId: pg.id,
        productName: '', // Empty - this is a product group only row
        list1: '',
        list2: '',
        rate: 1, // Fixed rate of 1 for product group rows
        isProductNameRow: false,
        color, // Color based on order frequency
        assignedEmployee: null, // For cross-selling reassignment
        ...orderHistory, // Include order history data
        ...monthlyData,
        totalQty,
        totalAmount,
      });
    });

    // Add 2 empty rows per pipeline (no product group selected yet - requires selection)
    for (let i = 0; i < 2; i++) {
      const monthlyData = {};
      MONTHS.forEach(month => {
        monthlyData[`${month.key}Amount`] = 0;
        monthlyData[`${month.key}Qty`] = 0;
      });

      products.push({
        id: `${pipeline.id}-empty-${i + 1}`,
        pipeline: pipeline.name,
        pipelineId: pipeline.id,
        productGroup: '', // Empty - requires selection
        productGroupId: '',
        productName: '',
        list1: '',
        list2: '',
        rate: 1,
        isProductNameRow: false,
        isEmptyRow: true, // Flag for empty rows requiring product group selection
        color: 'default',
        assignedEmployee: null,
        orderMonthsLastFY: 0,
        orderMonthsPrevFY: 0,
        orderCountLast8Months: 0,
        orderedLast2Months: false,
        orderedLast4Months: false,
        isNewProduct: false,
        totalOrdersAllTime: 0,
        ...monthlyData,
        totalQty: 0,
        totalAmount: 0,
      });
    }
  });

  return products;
};

// Generate product group budget (amount-based)
export const generateProductGroupBudget = (customerId) => {
  const groups = [];
  
  PIPELINES.forEach(pipeline => {
    PRODUCT_GROUPS.forEach(pg => {
      const monthlyData = {};
      
      MONTHS.forEach(month => {
        monthlyData[`${month.key}Amount`] = Math.floor(Math.random() * 500000) + 50000;
      });

      const totalAmount = MONTHS.reduce((sum, m) => sum + (monthlyData[`${m.key}Amount`] || 0), 0);

      groups.push({
        id: `${pipeline.id}-pg-${pg.id}`,
        pipeline: pipeline.name,
        pipelineId: pipeline.id,
        productGroup: pg.name,
        productGroupId: pg.id,
        ...monthlyData,
        totalAmount,
      });
    });
  });

  return groups;
};

// Get pipeline total
export const getPipelineTotal = (products) => {
  return products.reduce((sum, product) => sum + (product.totalAmount || 0), 0);
};

// Get grand total for all pipelines
export const getGrandTotal = (budgetData) => {
  return Object.values(budgetData).reduce((sum, products) => {
    return sum + getPipelineTotal(products);
  }, 0);
};

// Get unique divisions from customers
export const getUniqueDivisions = () => {
  return [...new Set(customers.map(c => c.division))];
};

// Get unique account managers from customers
export const getUniqueAccountManagers = () => {
  return [...new Set(customers.map(c => c.accountManager))];
};

// Get account manager approval status
export const getAccountManagerApprovalStatus = (accountManagerName) => {
  const am = ACCOUNT_MANAGERS.find(a => a.name === accountManagerName);
  return am ? am.isApproved : false;
};

// Group customers by division
export const groupCustomersByDivision = (customerList) => {
  const grouped = {};
  customerList.forEach(customer => {
    if (!grouped[customer.division]) {
      grouped[customer.division] = [];
    }
    grouped[customer.division].push(customer);
  });
  return grouped;
};

// Group customers by account manager
export const groupCustomersByAccountManager = (customerList) => {
  const grouped = {};
  customerList.forEach(customer => {
    if (!grouped[customer.accountManager]) {
      grouped[customer.accountManager] = [];
    }
    grouped[customer.accountManager].push(customer);
  });
  return grouped;
};

// Convert data to CSV for Excel download
export const convertToCSV = (data, columns) => {
  const headers = columns.map(c => c.label).join(',');
  const rows = data.map(row => 
    columns.map(c => {
      const value = row[c.key];
      // Escape commas and quotes
      if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value ?? '';
    }).join(',')
  );
  return [headers, ...rows].join('\n');
};

// Download CSV file
export const downloadCSV = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
